"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useIsOutsideParent;

require("core-js/modules/web.dom-collections.iterator.js");

var _react = require("react");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function useIsOutsideParent(child, parent, updater) {
  const [outsideProps, setoutsideProps] = (0, _react.useState)({
    top: undefined,
    right: undefined,
    bottom: undefined,
    left: undefined
  });
  (0, _react.useEffect)(() => {
    function handleResize() {
      var parentRect = parent.current.getBoundingClientRect();
      var childRect = child.current.getBoundingClientRect();

      let props = _objectSpread({}, outsideProps);

      if (parentRect.left > childRect.left) {
        //Left out
        props.left = true;
      } else {
        props.left = false;
      }

      if (parentRect.right < childRect.right) {
        //Right out
        props.right = true;
      } else {
        props.right = false;
      }

      if (parentRect.top > childRect.top) {
        props.top = true;
      } else {
        props.top = false;
      }

      if (parentRect.bottom < childRect.bottom) {
        props.bottom = true;
      } else {
        props.bottom = false;
      }

      setoutsideProps(props);
    }

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, [updater]);
  return outsideProps;
}